export enum AI_DESCRIPTION_TYPE {
    TRACK = 'materialUpload:AIDescription',
    TRACK_ERROR = 'materialUpload:AIDescription:error'
}

export enum AI_QUIZ_GENERATE_TYPE {
    TRACK = 'aiQuizGenerateTrack',
    TRACK_MODAL = 'aiQuizModal',
    TRACK_ERROR = 'aiQuizGenerateTrack:error'
}

export enum AI_QUIZ_DOWNLOAD_TYPE {
    TRACK = 'aiQuizDownloadTrack',
    TRACK_ERROR = 'aiQuizDownloadTrack:error'
}

export enum AI_TOOLS_TYPE {
    TRACK = 'AiTools',
    TRACK_ERROR = 'AiTools:error'
}

export enum AI_EVENT {
    CLICK_TOOL = 'AI:clickTool',
    VIEW_ALL_DOCUMENTS = 'AI:viewAllDocuments',
    VIEW_ALL_CHATS = 'AI:viewAllChats',
    SWITCH_SOURCE = 'AI:switchSource',
    NAVIGATE_DOCUMENTS = 'AI:navigateDocuments',
    VIEW_DOCUMENT = 'AI:viewDocument',
    VIEW_CHAT = 'AI:viewChat',
    EDIT_DOCUMENT = 'AI:editDocument',
    DELETE_DOCUMENT = 'AI:deleteDocument',
    VIEW_CART_MENU = 'AI:viewCardMenu',
    EXIT_DOCUMENT = 'AI:exitDocument',
    SIDEBAR_CLICK = 'AI:sidebarClick',
    HIDE_NOTIFICATION = 'AI:hideNotification',
    TOGGLE_VERSION = 'AI:toggleVersion',
    EDIT_TITLE = 'AI:editTitle',
    REFINE_SUGGESTION = 'AI:refineSuggestion',
    REFINE_CUSTOM = 'AI:refineCustom',
    DOWNLOAD_ICON_AI_CHAT = 'AI:downloadIconAIChat',
    COPY_ICON_AI_CHAT = 'AI:copyIconAIChat',
    REFINE_CUSTOM_AI_CHAT = 'AI:refineCustomAIChat',
    CRETE_INTERACTIVE_AI_CHAT = 'AI:createInteractiveAIChat',
    REFINE_AI_CHAT = 'AI:refinementSuggestionsAIChat',
    RENAME_TITLE_AI_CHAT = 'AI:renameTitleAIChat',
    CLICK_INFO_SETTINGS = 'AI:clickOnMoreInfoAISettings',
    EDIT_TEXT = 'AI:editText',
    COPY_TEXT = 'AI:copyText',
}
